import { Alert } from '@material-tailwind/react';
import { color } from '@material-tailwind/react/types/components/alert';
import React, { FC, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

type Props = {
  alertMessage?: string;
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  color?: color;
  //time in ms
  timeout?: number;
  fixedPosition?: boolean;
};

//Toast is a simple component that pops up a toast and clears after x ms
const Toast: FC<Props> = ({
  alertMessage,
  show,
  setShow,
  color,
  timeout,
  fixedPosition = false,
}) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  useEffect(() => {
    let alertCycle: NodeJS.Timeout;
    if (show) {
      alertCycle = setTimeout(() => setShow(false), timeout ? timeout : 5000);
    }
    return () => {
      if (alertCycle) clearTimeout(alertCycle);
    };
  }, [show]);

  const toastContent = (
    <div className={fixedPosition ? 'fixed top-28 right-5 z-[100]' : ''}>
      <Alert
        show={show}
        dismissible={{
          onClose: () => setShow(false),
        }}
        color={color ? color : 'teal'}
      >
        {alertMessage}
      </Alert>
    </div>
  );

  if (!mounted) return null;

  return fixedPosition
    ? createPortal(toastContent, document.body)
    : toastContent;
};

export default Toast;
